import { render, staticRenderFns } from "./quan.vue?vue&type=template&id=328eca2a&scoped=true"
import script from "./quan.vue?vue&type=script&lang=js"
export * from "./quan.vue?vue&type=script&lang=js"
import style0 from "./quan.vue?vue&type=style&index=0&id=328eca2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328eca2a",
  null
  
)

export default component.exports